import React, { useEffect } from "react";
import { Row } from "reactstrap";
import SummaryDetails from "./SummaryDetails";
import QASection from "./QASection";
import SfLoadingSkeleton from "components/Common/Loadings/SfLoadingSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { getCallSummary } from "store/call-summary/actions";
import { isGoalBrand } from "config";
import { CONVERSATIONS_SUMMARY_STATUS, STATUS_TYPES } from "helpers/sf_constants";

const CallSummary = ({ lead_id, setOverallConversation }) => {
    const dispatch = useDispatch()
    const { call_summary, call_summary_loading } = useSelector((state) => ({
        call_summary: state.CallSummary.call_summary,
        call_summary_loading: state.CallSummary.call_summary_loading
    }))
    useEffect(() => {
        if (lead_id) {
            dispatch(getCallSummary(lead_id))
        }
    }, [lead_id])
    const summaryDetails = isGoalBrand ? call_summary?.data?.qf_quote_call_summary : call_summary?.data?.quote_call_summary
    const summaryQA = isGoalBrand ? call_summary?.data?.qf_quote_call_qas : call_summary?.data?.quote_call_qas;
    return (
        <React.Fragment>
            <Row md={12}>
                {call_summary_loading ? (
                    <>
                        <SfLoadingSkeleton rows={10} cols={3} />
                    </>
                ) :
                    summaryDetails?.status === STATUS_TYPES.FAILED ?
                        <div className='no-summary-message'>{CONVERSATIONS_SUMMARY_STATUS.FAILED}</div>
                        : (
                            <>
                                <SummaryDetails call_summary={summaryDetails} />
                                <QASection call_summary_qa={summaryQA} lead_id={lead_id} status={summaryDetails?.status} call_summary={summaryDetails} setOverallConversation={setOverallConversation} />
                            </>
                        )}
            </Row>

        </React.Fragment>
    )
}

export default CallSummary;